import { useMutation } from "@tanstack/react-query";
import type {
  AuthOrderLinkVerifyTokenRequestType,
  AuthOrderLinkVerifyTokenResponseType,
} from "@sellar-io/api-v2/types";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useAuthVerifyOrderLinkToken = () => {
  return useMutation({
    mutationFn: (request: {
      data: AuthOrderLinkVerifyTokenRequestType;
      orderFlowToken: string;
    }) =>
      apiV2Request({
        user: undefined,
        business: null,
        method: "post",
        path: `auth/order-link/verify-token`,
        data: request.data,
        headers: {
          authorization: `Bearer ${request.orderFlowToken}`,
        },
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as AuthOrderLinkVerifyTokenResponseType,
      ),
  });
};
